import { createContext, useContext } from 'react'

export interface NotFoundContextValue {
  setNotFound: () => void
  isNotFound: boolean
}

export const NotFoundContext = createContext<NotFoundContextValue | null>(null)

export const useNotFound = () => useContext(NotFoundContext)
